<template>
  <div>
    <v-col class="d-flex ml-auto" cols="4" sm="4">
      <v-select v-model="yearSelected" label="Selecione" :items="years" dense outlined></v-select>
    </v-col>
    <highcharts v-if="loaded" :options="chartOptions" />
  </div>
</template>
<script>
  import GraficosService from '@/services/GraficosService';
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  import dayjs from 'dayjs';
  More(Highcharts);

  export default {
    name: 'AcompanhamentoCapex',
    data() {
      return {
        yearSelected: null,
        aic: [],
        ais: [],
        aicOpex: [],
        aisOpex: []
      };
    },
    computed: {
      loaded: function () {
        return (
          this.aic != null &&
          this.aic.length != 0 &&
          this.ais != null &&
          this.ais.length != 0 &&
          this.aicOpex != null &&
          this.aicOpex.length != 0 &&
          this.aisOpex != null &&
          this.aisOpex.length != 0
        );
      },
      chartOptions: function () {
        return {
          chart: {
            type: 'column',
            zoomType: 'xy',
            style: {
              fontFamily: 'muli'
            },
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: '',
            align: 'center'
          },
          xAxis: [
            {
              categories: this.dates,
              crosshair: true
            }
          ],
          yAxis: [
            {
              title: {
                text: 'MM R$',
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              },
              min: 0,
              labels: {
                formatter: function () {
                  return Highcharts.numberFormat(this.value / 1, 0, ',');
                },
                style: {
                  color: Highcharts.getOptions().colors[1]
                }
              }
            }
          ],
          tooltip: {
            shared: true,
            valuePrefix: 'R$ '
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: false
              },
              enableMouseTracking: true
            }
          },
          legend: {
            enabled: false,
            align: 'center',
            verticalAlign: 'bottom',
            y: 20,
            floating: true,
            backgroundColor: Highcharts.defaultOptions.legend.backgroundColor
          },
          series: [
            {
              name: 'P',
              type: 'column',
              data: this.P,
              color: Highcharts.getOptions().colors[0]
            },
            {
              name: 'M',
              type: 'column',
              data: this.M,
              color: Highcharts.getOptions().colors[1]
            },
            {
              name: 'S',
              type: 'column',
              data: this.S,
              color: Highcharts.getOptions().colors[2]
            },
            {
              name: 'O',
              type: 'column',
              data: this.O,
              color: Highcharts.getOptions().colors[3]
            },
            {
              name: 'OPEX',
              type: 'column',
              data: this.OPEX,
              color: Highcharts.getOptions().colors[4]
            }
          ]
        };
      },
      dates: function () {
        var array = [];
        var aux = this.aic;

        if (this.yearSelected && this.yearSelected !== 'LTM') {
          aux = aux.filter((item) => dayjs(item.DATA).format('YYYY') === this.yearSelected);
        }

        aux.forEach(function (element) {
          array.push(dayjs(element.DATA).format('MM/YYYY'));
        });

        array = [...new Set(array)];

        return array.slice(-12);
      },
      years: function () {
        var array = [];
        var aux = this.aic;
        aux.forEach(function (element, index) {
          array[index] = dayjs(element.DATA).format('YYYY');
        });

        array.push('LTM');

        return array.reverse();
      },
      P: function () {
        return this.getValorCalculado('P');
      },
      M: function () {
        return this.getValorCalculado('M');
      },
      S: function () {
        return this.getValorCalculado('S');
      },
      O: function () {
        return this.getValorCalculado('O');
      },
      OPEX: function () {
        return this.getOpexCalculado();
      }
    },
    mounted() {
      this.getDadosDashboard();
    },
    methods: {
      getDadosDashboard() {
        this.getDadosAic();
        this.getDadosAis();
        this.getDadosAicOpex();
        this.getDadosAisOpex();
      },
      getDadosAic() {
        return GraficosService.getDadosByNome('Acompanhamento do AIC :: AIC PMSO').then(({ data }) => {
          this.aic = Object.values(data.data);
        });
      },
      getDadosAis() {
        return GraficosService.getDadosByNome('Acompanhamento do AIC :: AIS PMSO').then(({ data }) => {
          this.ais = Object.values(data.data);
        });
      },
      getDadosAicOpex() {
        return GraficosService.getDadosByNome('Acompanhamento do AIC :: AIC OPEX').then(({ data }) => {
          this.aicOpex = Object.values(data.data);
        });
      },
      getDadosAisOpex() {
        return GraficosService.getDadosByNome('Acompanhamento do AIC :: AIS OPEX').then(({ data }) => {
          this.aisOpex = Object.values(data.data);
        });
      },
      getFiltroData() {
        var aic = this.aic;
        var unit = this.ais;
        var aicOpex = this.aicOpex;
        var unitOpex = this.aisOpex;

        var filtroDataAic = [];
        var filtroDataUnitizacao = [];
        var filtroDataAicOpex = [];
        var filtroDataUnitizacaoOpex = [];

        for (let index in this.dates) {
          filtroDataAic.push(aic.filter((item) => item.DATA.split('/').reverse().join('/') === this.dates[index]));
          filtroDataUnitizacao.push(unit.filter((item) => item.DATA.split('/').reverse().join('/') === this.dates[index]));
          filtroDataAicOpex.push(aicOpex.filter((item) => item.DATA.split('/').reverse().join('/') === this.dates[index]));
          filtroDataUnitizacaoOpex.push(
            unitOpex.filter((item) => item.DATA.split('/').reverse().join('/') === this.dates[index])
          );
        }

        return {
          dataAic: filtroDataAic,
          dataUnitizacao: filtroDataUnitizacao,
          dataAicOpex: filtroDataAicOpex,
          dataUnitizacaoOpex: filtroDataUnitizacaoOpex
        };
      },
      getValorCalculado(tipo) {
        var array = [];
        var filtroData = this.getFiltroData();
        var filtroDataAic = filtroData.dataAic;
        var filtroDataUnitizacao = filtroData.dataUnitizacao;

        array.push(this.calculaPrimeiroMes(filtroDataAic[0][0].DATA, tipo));

        for (let index in filtroDataAic) {
          if (index == 0) continue;

          let soma = 0;

          let Aic = filtroDataAic[index].filter((item) => item.TIPO === tipo);
          let Unit = filtroDataUnitizacao[index].filter((item) => item.TIPO === tipo);

          let valorAic = Aic[0]?.VALOR ?? 0;
          let valorUnit = Unit[0]?.VALOR ?? 0;

          if (typeof filtroDataAic[index - 1] !== 'undefined') {
            let AicAnt = filtroDataAic[index - 1].filter((item) => item.TIPO === tipo);
            let valorAicAnt = AicAnt[0]?.VALOR ?? 0;

            soma = parseFloat(valorUnit) + parseFloat(valorAic) - parseFloat(valorAicAnt);

            array.push(soma.toFixed(2));
          }
        }

        return array.map((value) => parseFloat(value));
      },
      calculaPrimeiroMes(data, tipo) {
        let dataAnt = this.getMesAnterior(data);

        let aic = this.aic;
        let unit = this.ais;

        var mesAic = aic.filter((item) => item.DATA === data && item.TIPO === tipo);
        var mesUnit = unit.filter((item) => item.DATA === data && item.TIPO === tipo);
        var mesAicAnt = aic.filter((item) => item.DATA === dataAnt && item.TIPO === tipo);

        let valorAic = mesAic[0]?.VALOR ?? 0;
        let valorUnit = mesUnit[0]?.VALOR ?? 0;
        let valorAicAnt = mesAicAnt[0]?.VALOR ?? 0;

        let soma = parseFloat(valorUnit) + parseFloat(valorAic) - parseFloat(valorAicAnt);

        return soma.toFixed(2);
      },
      getMesAnterior(anoMes) {
        let [ano, mes] = anoMes.split('/').map(Number);
        let data = new Date(ano, mes - 1, 1);

        data.setMonth(data.getMonth() - 1);

        let anoAnt = data.getFullYear();
        let mesAnt = String(data.getMonth() + 1).padStart(2, '0');

        return `${anoAnt}/${mesAnt}`;
      },
      //Calculo de Opex
      getOpexCalculado() {
        var array = [];
        var filtroData = this.getFiltroData();
        var filtroDataAicOpex = filtroData.dataAicOpex;
        var filtroDataUnitizacaoOpex = filtroData.dataUnitizacaoOpex;

        array.push(this.calculaPrimeiroMesOpex(filtroDataAicOpex[0][0].DATA));

        for (let index in filtroDataAicOpex) {
          if (index == 0) continue;

          let soma = 0;

          let Aic = filtroDataAicOpex[index];
          let Unit = filtroDataUnitizacaoOpex[index];

          let valorAic = Aic[0]?.VALOR ?? 0;
          let valorUnit = Unit[0]?.VALOR ?? 0;

          if (typeof filtroDataAicOpex[index - 1] !== 'undefined') {
            let AicAnt = filtroDataAicOpex[index - 1];
            let valorAicAnt = AicAnt[0]?.VALOR ?? 0;

            soma = parseFloat(valorUnit) + parseFloat(valorAic) - parseFloat(valorAicAnt);

            array.push(soma.toFixed(2));
          }
        }

        return array.map((value) => parseFloat(value));
      },
      calculaPrimeiroMesOpex(data) {
        let dataAnt = this.getMesAnterior(data);

        let aicOpex = this.aicOpex;
        let unitOpex = this.aisOpex;

        var mesAicOpex = aicOpex.filter((item) => item.DATA === data);
        var mesUnitOpex = unitOpex.filter((item) => item.DATA === data);
        var mesAicAntOpex = aicOpex.filter((item) => item.DATA === dataAnt);

        let valorAicOpex = mesAicOpex[0]?.VALOR ?? 0;
        let valorUnitOpex = mesUnitOpex[0]?.VALOR ?? 0;
        let valorAicAntOpex = mesAicAntOpex[0]?.VALOR ?? 0;

        let soma = parseFloat(valorUnitOpex) + parseFloat(valorAicOpex) - parseFloat(valorAicAntOpex);

        return soma.toFixed(2);
      }
    }
  };
</script>
